import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText } from '@strata/react-buttons';
import { Grid } from '@strata/react-grid';
import { MessagingBlock } from '@strata/react-messaging-block';
import { PageTitle } from '@strata/react-page-title';
import PropTypes from 'prop-types';

export const OrtfOutboundGridSection = ({
    title = undefined,
    columns,
    data,
    sortProperties,
    className = undefined,
    actions = undefined,
    subtitle = undefined,
    emptyMessage = undefined,
    isLoading = false,
    onRefresh = undefined,
    onRowClick = undefined,
}) => {
    const hasData = data.length > 0;

    return (
        <div className={className}>
            {title || actions || subtitle ? (
                <div
                    className="margin__bottom--medium flex__gap--medium"
                    style={{ alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <div>
                        {title ? <PageTitle title={title} /> : null}
                        {subtitle ? (
                            <MessagingBlock
                                className="margin__top--x-small"
                                size={MessagingBlock.Sizes.SMALL}
                                secondaryText={subtitle}
                            />
                        ) : null}
                    </div>
                    {actions ? <div className="flex__gap--medium">{actions}</div> : null}
                </div>
            ) : null}
            <div className="sds_ortf-outbound-grid">
                <Grid
                    columns={columns}
                    data={data}
                    enableSorting
                    isLoading={isLoading}
                    onRowClick={onRowClick}
                    noResults={
                        emptyMessage ? (
                            <div
                                className="padding__around--large flex__gap--medium"
                                style={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <MessagingBlock
                                    size={MessagingBlock.Sizes.MEDIUM}
                                    secondaryText={emptyMessage}
                                />
                                {onRefresh ? (
                                    <div className="sds_referral-grid__refresh">
                                        <ActionButtonText
                                            label="Refresh"
                                            leftIcon={IconNames.REFRESH}
                                            onClick={onRefresh}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        ) : undefined
                    }
                    sortProperties={sortProperties}
                    topRightContent={
                        hasData && onRefresh ? (
                            <div className="sds_referral-grid__refresh sds_ortf-outbound-grid__refresh">
                                <ActionButtonText
                                    label="Refresh"
                                    leftIcon={IconNames.REFRESH}
                                    onClick={onRefresh}
                                />
                            </div>
                        ) : undefined
                    }
                />
            </div>
        </div>
    );
};

OrtfOutboundGridSection.propTypes = {
    title: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    sortProperties: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            desc: PropTypes.bool,
        }),
    ).isRequired,
    className: PropTypes.string,
    actions: PropTypes.node,
    subtitle: PropTypes.string,
    emptyMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    onRefresh: PropTypes.func,
    onRowClick: PropTypes.func,
};
